import clsx from 'clsx';
import { arrayOf, bool, func, oneOf, shape, string } from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Icon } from 'components';

import 'assets/styles/components/switch-buttons.scss';

const SwitchButtons = ({ buttons, onSelect, activeButton = null }) => {
  const { t } = useTranslation();

  return (
    buttons.length && (
      <div className="flex w-fit">
        {buttons.map((button, i) => {
          const active = activeButton === button.name;

          return (
            <div className="relative switch-btn-container" key={`button-${button.name}-${i}`}>
              <button
                type="button"
                className={clsx('switch-btn', {
                  'has-icon': button.icon?.name,
                  active,
                  [button.selectedClass]: active && button.selectedClass
                })}
                disabled={button.disabled || active}
                onClick={() => onSelect(button)}
                data-test-id={button?.dataTestId ?? ''}
              >
                {button.icon?.name && <Icon name={button.icon.name} iconStyle={button.icon?.style} />}
                <span className="text-balance">{t(button.labelKey)}</span>
              </button>

              {!!button?.tagElement && button.tagElement}
            </div>
          );
        })}
      </div>
    )
  );
};

SwitchButtons.propTypes = {
  buttons: arrayOf(
    shape({
      name: string.isRequired,
      labelKey: string.isRequired,
      selectedClass: string,
      icon: shape({ name: string.isRequired, style: oneOf(['fas', 'fad']) }),
      disabled: bool,
      dataTestId: string
    })
  ).isRequired,
  onSelect: func.isRequired,
  activeButton: string
};

export default SwitchButtons;
